export default "__VITE_ASSET__sFYwZoVi__"